import { createAsyncThunk } from '@reduxjs/toolkit';

import { setNavReady, setNavItem } from '../init';
import { aflApi } from '../../api/afl-api';
import { changeSeason } from '.';

export const changeCompetition = createAsyncThunk(
    'nav/changeCompetition',
    async (
        { competition, season, round, removeFinals, skipRound },
        { dispatch }
    ) => {
        dispatch(setNavReady(false));

        const { data: compData } = await dispatch(
            aflApi.endpoints.getCompetitions.initiate()
        );

        const foundComp = compData.find(
            (item) => item.id === parseInt(competition.id)
        );

        // Set 'competition' nav item in the state
        dispatch(
            setNavItem({
                navItem: 'competition',
                value: foundComp || competition
            })
        );

        // Get comp seasons for the selected competition
        const { data: seasons } = await dispatch(
            aflApi.endpoints.getCompSeasons.initiate({
                competitionId: foundComp ? foundComp.id : competition.id
            })
        );

        // Set 'seasons' nav item in the state
        dispatch(setNavItem({ navItem: 'seasons', value: seasons }));

        const selectedSeason =
            seasons.find((item) => item.id === season?.id) || seasons[0];

        // Dispatch changeSeason thunk
        await dispatch(
            changeSeason({
                season: selectedSeason,
                round,
                removeFinals,
                skipRound
            })
        );
    }
);
